import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector'; // Tự động detect ngôn ngữ
import en from 'locales/enUS.json'; // Import file JSON từ src
import vi from 'locales/viVN.json';
import { getConstants } from 'utils/constants';

const { LANGUAGE_STORAGE_KEY, LANGUAGE_DEFAULT } = getConstants();

i18n
  .use(LanguageDetector) // Phát hiện ngôn ngữ.use(initReactI18next) // Kết nối i18next với React
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en }, // Gán dữ liệu JSON vào i18next
      vi: { translation: vi },
    },
    lng: localStorage.getItem(LANGUAGE_STORAGE_KEY) || LANGUAGE_DEFAULT, // Ngôn ngữ mặc định
    fallbackLng: 'en', // Nếu không tìm thấy key, dùng tiếng Anh
    debug: false, // Bật log để kiểm tra
    detection: {
      order: ['localStorage', 'navigator'], // Ưu tiên localStorage
      lookupLocalStorage: LANGUAGE_STORAGE_KEY, // Đổi key localStorage
      caches: ['localStorage'], // Lưu vào localStorage
    },
    interpolation: { escapeValue: false }, // Không escape HTML tránh lỗi XSS
  });

export default i18n;
